import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Resolve a possibly-relative image URL to an absolute one against
 * REACT_APP_BACKEND_URL. Use for any image stored via the admin upload
 * endpoint (returns paths like "/api/uploads/abc.jpg").
 *
 *   resolveImageUrl("https://cdn.example.com/x.jpg")  -> unchanged
 *   resolveImageUrl("/api/uploads/abc.jpg")           -> "${BACKEND}/api/uploads/abc.jpg"
 *   resolveImageUrl("data:image/jpeg;base64,…")       -> unchanged
 *   resolveImageUrl("")                                -> ""
 */
export function resolveImageUrl(url) {
  if (!url) return "";
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  if (url.startsWith("/")) return `${base}${url}`;
  return `${base}/${url}`;
}
